import { authApi, publicApi } from "./api";

/* ================= TOKEN ================= */

const saveToken = (token) => {
    if (!token) return;
    localStorage.setItem("authToken", token);
    sessionStorage.setItem("authToken", token);
};

export const logoutUser = () => {
    localStorage.removeItem("authToken");
    sessionStorage.removeItem("authToken");
};

/* ================= REGISTER ================= */

export const registerUser = async (data) => {
    try {
        const res = await publicApi.post("/register", data);
        return res.data;
    } catch (err) {
        throw (
            err?.response?.data?.message ||
            err?.response?.data ||
            "Registration failed"
        );
    }
};

/* ================= LOGIN ================= */

export const loginUser = async (data) => {
    try {
        const res = await publicApi.post("/login/authenticate", data);
        const result = res.data;

        // 🔐 save token immediately if returned
        if (result?.token) {
            saveToken(result.token);
        }

        return result;
    } catch (err) {
        throw err;
    }
};

/* ================= 2FA ================= */

export const verify2FA = async (data) => {
    try {
        const res = await publicApi.post("/2fa/verify", data);

        if (res.data?.token) {
            saveToken(res.data.token);
        }

        return res.data;
    } catch (err) {
        throw (
            err?.response?.data?.message ||
            err?.response?.data ||
            "2FA verification failed"
        );
    }
};

/* ================= CURRENT USER ================= */

export const getCurrentUser = async () => {
    try {
        const res = await authApi.get("/login/me");
        return res.data;
    } catch (err) {
        throw (
            err?.response?.data?.message ||
            "Failed to fetch user"
        );
    }
};